package com.wintermar.inspection.feature.presentation.inspection.landing.widget.inspection_preview

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel

@Composable
actual fun InspectionPreviewModal(
    show: Boolean,
    labelAction: String,
    labelSecondAction: String,
    data: InspectionModel,
    templateOptions: List<TemplateOptionModel>,
    onAction: () -> Unit,
    onSecondAction: () -> Unit,
    onDismiss: () -> Unit
) {
    ModalDialog(
        show = show,
        action = ModalAction.default().copy(
            withBackgroundHeader = true,
            widthButtonBasedOnText = true,
            showAction = true,
            isSameWeight = false,
            label = labelAction,
            secondLabel = labelSecondAction.ifEmpty { null },
            onClick = {
                onAction()
                onDismiss()
            },
            secondOnClick = {
                onSecondAction()
                onDismiss()
            }
        ),
        onDismiss = {
            onDismiss()
        }
    ) { verticalPadding ->
        InspectionPreview(
            data = data,
            verticalPadding = verticalPadding,
            templateOptions = templateOptions
        )
    }
}
